
    import { defineComponent } from 'vue';
    import { ProductPageViewModel } from '../../models/Website/ProductPageViewModel';
    import AxiosService from '@/api-services/axios.service';
    import truncate from 'vue-truncate-collapsed';
    import notify from '@/plugins/notify';
    import analytics, { gtagItemModel } from '@/plugins/analytics';
    import SellingPoints from './SellingPoints.vue';
    import SubscriptionsBanner from './Banners/SubscriptionsBanner.vue';
    import NetflixPromoBanner from './Banners/NetflixPromoBanner.vue';
    import NetflixCandyPromoBanner from './Banners/NetflixCandyPromoBanner.vue';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { Navigation, Pagination, Autoplay} from 'swiper';
    const API_CONTROLLER = '/api/Catalog';
    //const API_MYPAGE = '/api/MyPage';
    const API_PARTNER = '/api/Partner';
    const API_SUBSCRIPTION = '/api/Subscription';

    export default defineComponent({
        created: function () {
            this.$store.state.showFooter = true;
        },
        head: {
            title: function () {
                return {
                    inner: (<any>this).Product.MetaTitle ? (<any>this).Product.MetaTitle : (<any>this).Product.Name
                }
            },
            meta: function () {
                return (<any>this).$getHeadMeta({
                    contentTitle: (<any>this).Product.MetaTitle ? (<any>this).Product.MetaTitle : (<any>this).Product.Name,
                    description: this.$data.Product.MetaDescription ? (<any>this).Product.MetaDescription : (<any>this).Product.Description,
                    keywords: this.$data.Product.Keywords,
                    imageurl: (<any>this).$imgix(this.$data.Product.PhotoUrl, '?w=646&h=485&auto=compress,format&fit=crop')
                });
            }
        },
        data: function () {
            return {
                ready: false,
                CollapseVisible: false,
                modules: [Navigation, Autoplay],
                Product: new ProductPageViewModel(),
                PartnerList: [],
                PartnerSlideIndex: 0,
                Selected: null,
                Comment: "",
                CustomerReviews: [
                    //{
                    //    Id: 121,
                    //    Rating: 3,
                    //    ImgSrc: "https://picsum.photos/30/30/?image=283",
                    //    Name: "Jans Petersen",
                    //    Description: "Enhver har ret til undervisning. Undervisningen skal være gratis, i det mindste på de elementære og grundlæggende trin. Elementær undervisning skal være obligatorisk. Las mere"
                    //},

                ],

                PreviousProductslItems: [
                    //{
                    //    ImgSrc: "https://picsum.photos/800/450/?image=201",
                    //    Name: "Champagne Akademiet",
                    //    Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"
                    //},
                    //{
                    //    ImgSrc: "https://picsum.photos/800/450/?image=202",
                    //    Name: "Winetime",
                    //    Description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"

                    //}
                ]
            }
        },
        watch: {
            '$store.state.ActiveLanguageId': function () {
                (<any>this).getProduct(this.$route.query.Id, this.$route.params.slug,this.$store.state.ActiveLanguageId);
                //(<any>this).getpartnerlist(this.$store.state.ActiveLanguageId);
            },
        },
        mounted() {
            (<any>this).getProduct(this.$route.query.Id, this.$route.params.slug,this.$store.state.ActiveLanguageId);
            //(<any>this).getpartnerlist(this.$store.state.ActiveLanguageId);
        },
        methods: {
            getProduct: function (productId, slug, languageId) {
                if (languageId) {
                    this.$data.ready = false;
                    AxiosService.getMultiParams(API_CONTROLLER + '/product', { Id: productId, Slug: slug, LanguageId: languageId })
                        .then(response => {
                            if (!response.data) { this.$router.push({ path: '/404' })}
                            this.$data.Product = new ProductPageViewModel(response.data);
                            analytics.trackViewContent(
                                this.$data.Product.Price,
                                this.$data.Product.Currency,
                                [new gtagItemModel({
                                    item_id: productId,
                                    item_name: this.$data.Product.Name,
                                    price: this.$data.Product.Price,
                                    currency: this.$data.Product.Currency,
                                    quantity: 1
                                })]
                            );
                            this.$emit('updateHead');
                            this.$data.ready = true;
                        }).catch(er => this.$router.push({ path: '/404' }));
                }
            },
            // subscribe: function () {
            //     this.$data.ready = false;
            //     if (this.$data.Product.IsActiveSubscribe) {
            //        (<any>this).unSubscribe();
            //     } else {
            //         this.$router.push({ name: 'CheckOut', params: { productId: this.$data.Product.Id } });
            //         AxiosService.getMultiParams(API_MYPAGE + '/hasfulladdressandmoney', { price: this.$data.Product.Price })
            //             .then(response => {
            //                 if (response.data) {
            //                     AxiosService.create(API_SUBSCRIPTION + '/subscribe', {
            //                         DeliveryFrequencyId: this.$data.DeliveryFrequencyId,
            //                         ProductCategoryId: this.$data.Product.Id,
            //                         Quantity: this.$data.Quantity,
            //                         Comment: this.$data.Comment,
            //                         IsReceiveNewsletter: false,
            //                         OnCustomerAddress: true,
            //                         ReturnUrl: `${window.location.origin}/${this.$i18n.locale}${this.$t('Pages.OrderConfirm.path').toString()}` ,
            //                     }).then(response => {
            //                             if (response.data.ReturnUrl){
            //                                 window.location.href = response.data.ReturnUrl;
            //                             }; 
            //                             if (response.data.PaymentStatus == "succeeded") {
            //                                 analytics.trackPurchase([this.$data.Product.Id], this.$data.Product.Price, this.$data.Product.Currency);
            //                                 this.$router.push({ name: 'OrderConfirm', params: { orderId: response.data.OrderId } });
            //                             };   
            //                             this.$root.$emit('bv::toggle::collapse', `accordion-${this.$data.Product.Id}`)                                    
            //                             this.$data.ready = true;
            //                     }).catch(er => { notify.axiosError(er); this.$data.ready = true; });
            //                 } else {
            //                     this.$router.push({ name: 'CheckOut', params: { productId: this.$data.Product.Id, frequency: this.$data.DeliveryFrequencyId, count: this.$data.Count } });
            //                 }
            //             }).catch(er => { notify.axiosError(er); this.$data.ready = true; });
            //     }
            // },
            unSubscribe: function () {
                if (this.$data.Product.SubscriptionId) {
                     this.$data.ready = false;
                    AxiosService.post(API_SUBSCRIPTION + '/unsubscribe', { Id: this.$data.Product.SubscriptionId }
                    ).then(response => {
                        analytics.trackUnsubscribe([this.$data.Product.Id], this.$data.Product.Price, this.$data.Product.Currency);
                        this.$router.push({ name: 'UnsubscribeConfirm', params: { productName: this.$data.Product.Name, plannedSubscriptionEndDate: response.data.PlannedSubscriptionEndDate }});
                        this.$data.ready = true;
                        this.$root?.$emit('bv::toggle::collapse', `accordion-${this.$data.Product.Id}`)
                    }).catch(er => {notify.axiosError(er);  this.$data.ready = true; });
                }
               
            },
            getpartnerlist: function (languageId) {
                if (languageId) {
                    AxiosService.getMultiParams(API_PARTNER + '/getpartnerlist', { languageId: languageId })
                        .then(response => this.$data.PartnerList = response.data)
                        .catch(er => notify.axiosError(er));
                }
            },
        },
        computed: {
            BreadcrumbsItems() {
                return [
                    { "to": "/", "text": this.$t('general.brand-name') },
                    { "to": this.$t('Pages.Catalog.path').toString(), "text": this.$t('website.ourproducts') },
                    { "to": this.$t('Pages.ProductPage.path').toString(), "text": this.$data.Product.Name || "" }
                ]
            }
        },
        components: {
            truncate,
            SellingPoints,
            SubscriptionsBanner,
            Swiper,
            SwiperSlide,
            NetflixPromoBanner,
            NetflixCandyPromoBanner
        }
    })

